export type AudienceType = 'all' | 'specific';

export type PostedMessage = {
  id: string;
  title: string;
  body: string;
  createdAt: string;
  audienceType: AudienceType;
  roles: string[];
  roleLabels: string[];
  burnCenterIds: number[];
  burnCenterLabels: string[];
  accessLevels: string[];
  isAllUsers: boolean;
  isAllRoles: boolean;
  isAllBurnCenters: boolean;
};

export type CreateMessagePayload = {
  title: string;
  body: string;
  roles: string[];
  burnCenterIds: number[];
  accessLevels: string[];
};

export type UpdateMessagePayload = CreateMessagePayload;

export type AnnouncementResponse = {
  id: number;
  title: string;
  body: string;
  createdAt: string;
  roles: string[];
  roleLabels: string[];
  burnCenterIds: number[];
  burnCenterLabels: string[];
  accessLevels: string[];
  isAllUsers: boolean;
  isAllRoles: boolean;
  isAllBurnCenters: boolean;
};

export type AnnouncementListResponse = {
  historyMonths?: number;
  items?: AnnouncementResponse[];
};

type AnnouncementListPayload =
  | AnnouncementListResponse
  | AnnouncementResponse[]
  | null
  | undefined;

export const parseAnnouncementList = (
  data: AnnouncementListPayload,
): { historyMonths?: number; items: AnnouncementResponse[] } => {
  if (!data) {
    return { items: [] };
  }

  if (Array.isArray(data)) {
    return { items: data };
  }

  const record = data as AnnouncementListResponse & {
    HistoryMonths?: number;
    Items?: AnnouncementResponse[];
  };

  return {
    historyMonths: record.historyMonths ?? record.HistoryMonths,
    items: record.items ?? record.Items ?? [],
  };
};

export const toPostedMessage = (announcement: AnnouncementResponse): PostedMessage => {
  const roles = announcement.roles ?? [];
  const roleLabels = announcement.roleLabels ?? [];
  const burnCenterIds = announcement.burnCenterIds ?? [];
  const burnCenterLabels = announcement.burnCenterLabels ?? [];
  const accessLevels = announcement.accessLevels ?? [];
  const isAllRoles = announcement.isAllRoles ?? roles.length === 0;
  const isAllBurnCenters = announcement.isAllBurnCenters
    ?? (burnCenterIds.length === 0 && accessLevels.length === 0);
  const isAllUsers = announcement.isAllUsers ?? (isAllRoles && isAllBurnCenters);

  return {
    id: String(announcement.id),
    title: announcement.title,
    body: announcement.body,
    createdAt: announcement.createdAt,
    audienceType: isAllUsers ? 'all' : 'specific',
    roles,
    roleLabels,
    burnCenterIds,
    burnCenterLabels,
    accessLevels,
    isAllUsers,
    isAllRoles,
    isAllBurnCenters,
  };
};
